import { render, staticRenderFns } from "./VoucherCodeWrapper.vue?vue&type=template&id=4a61724c"
import script from "./VoucherCodeWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./VoucherCodeWrapper.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports